import React from 'react'
import { View, Text, ActivityIndicator } from 'react-native'
import BlurView from '../BlurView'
import { useAppTheme } from '#app/theme'

interface Phase {
  label: string
  value: string
  loading?: boolean
}

interface Props {
  total?: {
    label: string
    value: string
    loading?: boolean
  }
  phases: Phase[]
}

export default function MetricGroup ({ total, phases }: Props) {
  const theme = useAppTheme()

  return (
    <BlurView
      tint={theme.blurView.tint}
      intensity={theme.blurView.intensity}
      style={[{ margin: 5, borderRadius: 12, overflow: 'hidden' }, { ...theme.border }]}
    >
      {total != null && (
        <View style={{ padding: 16, paddingBottom: 14 }}>
          <Text style={{
            fontSize: 11,
            fontWeight: '600',
            letterSpacing: 0.8,
            textTransform: 'uppercase',
            color: theme.textColor,
            marginBottom: 6,
            opacity: 0.6
          }}>
            {total.label}
          </Text>
          {total.loading === true
            ? <ActivityIndicator color={theme.titleLoading.indicatorColor} size="small" style={{ alignSelf: 'flex-start' }} />
            : <Text style={{ fontSize: 34, fontWeight: '200', color: theme.home.topConsumption.textColor }}>
                {total.value}
              </Text>
          }
        </View>
      )}

      <View style={{ height: 1, backgroundColor: 'rgba(255,255,255,0.08)' }} />

      <View style={{ flexDirection: 'row' }}>
        {phases.map((phase, i) => (
          <View
            key={i}
            style={{
              flex: 1,
              padding: 12,
              borderLeftWidth: i > 0 ? 1 : 0,
              borderLeftColor: 'rgba(255,255,255,0.08)'
            }}
          >
            <Text style={{
              fontSize: 10,
              fontWeight: '600',
              letterSpacing: 0.8,
              textTransform: 'uppercase',
              color: theme.textColor,
              marginBottom: 4,
              opacity: 0.6
            }}>
              {phase.label}
            </Text>
            {phase.loading === true
              ? <ActivityIndicator color={theme.titleLoading.indicatorColor} size="small" style={{ alignSelf: 'flex-start' }} />
              : <Text style={{ fontSize: 20, fontWeight: '300', color: theme.home.topConsumption.textColor }}>
                  {phase.value}
                </Text>
            }
          </View>
        ))}
      </View>
    </BlurView>
  )
}
